module.exports = __webpack_public_path__ + "img/gxnzjl.f9e4aff8.png";